import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message, Modal } from 'antd';
import { getProfileCompany } from '../../redux/actions/profile_company';
import { getImageOffice } from '../../redux/actions/upload';
import useTrans from '../../hooks/useTrans';
import MetaSeo from '../MetaSeo';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

export default function About(props) {
  const [isShowModal, setIsShowModal] = useState(false);
  const refYoutobe = useRef();
  const refClickYoutobe = useRef();
  const [list_image_office, setListImageOffice] = useState([]);
  const [display_modal, setDisplayModal] = useState('none');
  const [data_modal, setDataModal] = useState({});
  const [profile, setProfile] = useState();
  const trans = useTrans();
  const wrapperRef = useRef(null);

  const [flag, setFlag] = useState(false);


  const onChange = key => {
    console.log(key);
    setFlag(!flag);
  };

  const useOutsideAlerter = ref => {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDisplayModal('none');
        }
      }

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  useEffect(() => {
    if (display_modal === 'block') {
      document.querySelectorAll('.modal-body-top')[0]?.scrollIntoView(false);
      document.body.style.overflowY = "hidden";
    }
    else {
      document.body.style.overflowY = "scroll";
    }
  }, [display_modal]);


  useOutsideAlerter(wrapperRef);

  const handleClickOut = event => {
    const { target } = event;
    if (
      refYoutobe &&
      refClickYoutobe &&
      refClickYoutobe.current &&
      refYoutobe.current &&
      !refYoutobe.current.contains(target) &&
      !refClickYoutobe.current.contains(target)
    ) {
      setIsShowModal(false);
    }
  };
  useEffect(() => {
    getListImageOffice();
    getProfile();
    window.addEventListener('click', handleClickOut);
    return () => {
      window.removeEventListener('click', handleClickOut);
    };
  }, []);
  const getListImageOffice = async () => {
    const data = await getImageOffice();
    setListImageOffice(data);
  };
  const getProfile = async () => {
    const data = await getProfileCompany();
    setProfile(data);
  };
  const setting_feedback = {
    loop: false,
    margin: 0,
    arrows: false,
    speed: 500,
    autoplay: true,
    nav: false,
    dots: true,
    responsive: [
      {
        items: 1,
      },
    ],
    customPaging: index => {
      return <button></button>;
    },
  };
  const setting_office = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <button class='slick-prev slick-arrow' aria-label='Next' type='button'>
        <img src='./assets/images/home/icon-next.svg' />
      </button>
    ),
    nextArrow: (
      <button class='slick-next slick-arrow' aria-label='Next' type='button'>
        <img src='./assets/images/home/icon-next.svg' />
      </button>
    ),
  };

  // some-image-slider
  const someImageSlider = {
    centerMode: true,
    centerPadding: '295px',
    slidesToShow: 1,
    dots: false,
    speed: 400,
    prevArrow: (
      <button
        class='slick-prev slick-arrow'
        aria-label='Previous'
        type='button'
      >
        <img
          src='/assets/images/icon/icon-left.svg'
          class='slide-arrow prev-arrow'
        />
      </button>
    ),
    nextArrow: (
      <button class='slick-next slick-arrow' aria-label='Next' type='button'>
        <img
          src='/assets/images/icon/icon-right.svg'
          class='slide-arrow prev-arrow'
        />
      </button>
    ),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '40px',
        },
      },
    ],
  };

  const setting = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    arrows: false,
    dots: true,
    loop: false,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          vertical: true,
          verticalSwiping: true,
        },
      },
    ],
    nextArrow: <div></div>,
    prevArrow: <div></div>,
    customPaging: index => {
      return <button>{index === 6 ? 2012 : 2022 - index}</button>;
    },
  };
  const data_array = [
    {
      name: 'グエン・クイ・ドウック',
      job: 'CEO / TCOM JAPAN',
      image: '/assets/images/about/member1.jpeg',
      image_md: '/assets/images/about/md-member-1.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    // {
    //   name: '吉元大',
    //   job: '取締役',
    //   image: '/assets/images/about/yoshi.png',
    //   image_md: '/assets/images/about/yoshi.png',
    //   description:
    //     '',
    // },
    {
      name: 'レ・スアン・ハ',
      job: '取締役',
      image: '/assets/images/about/member4.webp',
      image_md: '/assets/images/about/md-member-4.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'ディン・コック・クオン',
      job: 'CEO / TCOM',
      image: '/assets/images/about/member2.webp',
      image_md: '/assets/images/about/md-member-2.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'グエン・ヴァン・フォン',
      job: 'CTO/TCOM VN',
      image: '/assets/images/about/member3.webp',
      image_md: '/assets/images/about/md-member-3.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    // {
    //   name: 'グエン・トロン・ホア',
    //   job: 'CTO / TCOM, CEO / EyeFire',
    //   image: '/assets/images/about/member5.webp',
    //   image_md: '/assets/images/about/md-member-5.png',
    //   description:
    //     'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    // },
    // {
    //   name: 'レ・ミン・ソン',
    //   job: 'Chief of Mobile Department',
    //   image: '/assets/images/about/member6.webp',
    //   image_md: '/assets/images/about/md-member-6.png',
    //   description:
    //     'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    // },
    {
      name: 'ゴ・チュン・ヒエウ',
      job: 'CEO TCOM GLOBAL',
      image: '/assets/images/about/member7.webp',
      image_md: '/assets/images/about/md-member-7.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'ル・コック・フン',
      job: 'Chief of Infra Department',
      image: '/assets/images/about/member8.webp',
      image_md: '/assets/images/about/md-member-8.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
    {
      name: 'ゴ・ ティ ・フォン・ タオ',
      job: 'QA/QC Leader',
      image: '/assets/images/about/member9.webp',
      image_md: '/assets/images/about/md-member-9.png',
      description:
        'Hieu experience in operational management and system development for large international corporations. She is in charge of developing NTQ-ers, including recruitment, training, human resource development, and organizational structure-buildingpolicies. Lan has aided NTQ in creating a professional employee-centric working environment that adheres tointernational standards. She considers',
    },
  ];
  const displayModal = item => {
    setDisplayModal('block');
    // document.getElementsByClassName('modal-body-top')[0]?.scrollIntoView(false);
    // document.body.style.overflow = "hidden";
    setDataModal(item);
  };

  const dataSeo = {
    url: process.env.NEXT_PUBLIC_SEO_URL,
    type: 'website',
    title: '概要 | TCOM JAPAN',
    description:
      'TCOM JAPANは、ベトナムを代表する日本のオフショア開発会社です。 優秀なエンジニアのチーム、ソフトウェア開発プロセス、専門的な品質管理により、最高の品質と最適なコストで日本市場にオフショアサービスを提供します。 ',
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    // image: 'https://staging.tcom-japan.com/assets/images/about/gallery-2.png',
    card: 'summary_large_image',
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <div id='about'>
        <div className='main-content'>
          <div className='r-top-banner'>
            <img
              className='w-100'
              src='/assets/images/about/top-banner.png'
              alt=''
            />
            <div className='content-sp'>
              <h3>{trans.about.title}</h3>
              <p>{trans.about.desc}</p>
            </div>
          </div>
          <img
            className='w-100 img-about-us-sp'
            src='/assets/images/about/about-us-sp.png'
            alt=''
          />
          <div className='r-about-us'>
            <div className='container'>
              <div className='row'>
                <div className='col-12 col-lg-5 col-left'>
                  <img
                    className='img-about-us-pc'
                    src='/assets/images/about/about-us.png'
                    alt=''
                  />
                </div>
                <div className='col-12 col-lg-7 col-right'>
                  <div className='box'>
                    <div className='title-left'>
                      <h3>{trans.about.about_us}</h3>
                      <p>{trans.about.about_us_text1}</p>
                      <p>{trans.about.about_us_text2}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='r-company-profile'>
            <div className='container'>
              <div className='title-center'>
                <h3>{trans.about.profile_title}</h3>
              </div>
              <div className='row row-pc'>
                <div className='col-12 col-lg-12'>
                  <div className='inner'>
                    {/* <h5>{trans.about.tcom_japan}</h5> */}
                    <dl className='list horizon dt-10' style={{padding: '10px', border: 'solid 1px #ccc'}}>
                      <dt>会社名</dt>
                      <dd>
                      TCOM JAPAN 株式会社<br/>
                        インボイス登録番号：T4012803002507
                      </dd>
                      <dt>住所</dt>
                      <dd>
                        〒190-0023 <br/>
                        東京都⽴川市柴崎町 3-8-5 ⽴川 NX ビル 5F
                      </dd>
                      <dt>資本金</dt>
                      <dd>
                      ５００万円
                      </dd>
                      <dt>設⽴</dt>
                      <dd>
                        <p>2021 年 5 ⽉</p>
                      </dd>
                      <dt>役員</dt>
                      <dd>
                        代表取締役 グエン・クイ・ドウック < br />
                        取締役 レ・スアン・ハー
                      </dd>

                      <dt>事業内容</dt>
                      <dd>
                        オフショア開発<br />
                        システム開発支援<br />
                        アプリ開発支援<br />
                        人工知能研究開発<br />
                        ブロックチェーン研究開発<br />
                        SES人材
                      </dd>
                      <dt>連絡先</dt>
                      <dd><a style={{ color: '#007bff', textDecoration: 'underline' }}>sales@tcom-japan.com</a>
                        <p>042 512 9160</p>
                      </dd>
                      <dt>加入団体立</dt>
                      <dd>
                        立川商工会議所<br />
                        青梅商工会議<br />
                        立川法人会
                      </dd>
                      <dt>取引銀行</dt>
                      <dd>
                        菱ＵＦＪ銀行　日本橋支店
                      </dd>
                    </dl>
                  </div>
                  <div className='inner'>
                    <dl className='list horizon dt-10' style={{padding: '10px', border: 'solid 1px #ccc', marginTop: '30px'}}>
                      <dt>親会社</dt>
                      <dd>
                        TCOM CORPORATION<br />
                        本社(ハノイ)<br />
                        3rd floor, Fafim A Building, 19 Nguyen Trai Street, Khuong Dinh Ward, Ha Noi City<br />
                        開発拠点（ホーチミン市）<br />
                        5F, VTD Building 17 Ho Van Hue Street, Duc Nhuan Ward, Ho Chi Minh City<br />
                      </dd>
                      <dt>資本金</dt>
                      <dd>
                      8.8億ベトナムドン (約4,400万円)
                      </dd>
                      <dt>設⽴ </dt>
                      <dd>
                      2012 年 1 ⽉
                      </dd>
                      <dt>従業員数 </dt>
                      <dd>
                      150名
                      </dd>
                      <dt>役員 </dt>
                      <dd>
                        代表取締役 ディン・コック・クオン<br />
                        取締役副社長 レ・スアン・ハー<br />
                        取締役 グエン・ヴァン・フォン<br />
                        取締役ゴ・チュン・ヒエウ
                      </dd>
                      <dt>事業内容 </dt>
                      <dd>
                        オフショア開発<br />
                        システム開発支援<br />
                        アプリ開発支援<br />
                        人工知能研究開発<br />
                        ブロックチェーン研究開発<br />
                        SES人材
                      </dd>
                      <dt>連絡先</dt>
                      <dd>
                        <p>+84-24-3910-2030</p>
                      </dd>
                      <dt>加入団体</dt>
                      <dd>
                        VINASA(ベトナムソフトウェアおよびITサービス協会)
                      </dd>
                      <dt>取得資格</dt>
                      <dd>
                        ISO27001:2022情報セキュリティマネジメント<br/>
                        ISO9001:2015 品質マネジメントシステム
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='r-some-image'>
            <div className='container-fluid'>
              <div className='title-center'>
                <h3>{trans.about.some_pics}</h3>
              </div>
              <div className='inner'>
                <div className='some-image-slider'>
                  <Slider {...someImageSlider}>
                    <div className='item'>
                      <img src='/assets/images/about/image-1.png' alt='' />
                    </div>
                    <div className='item'>
                      <img src='/assets/images/about/image-2.png' alt='' />
                    </div>
                    <div className='item'>
                      <img src='/assets/images/about/image-3.png' alt='' />
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div> */}
          <div className='r-our-team'>
            <div className='container'>
              <div className='title-center'>
                <h3>{trans.about.us_title}</h3>
              </div>
            </div>
            <div className='inner'>
              <div className='label'>{trans.about.us_title}</div>
              <div className='box-content'>
                <ul>
                  {/* Modal */}
                  {/* <div className='box'  onClick={() => { setDisplayModal(true); }} data-toggle='modal' data-target='#exampleModal'> */}
                  <div
                    className={
                      display_modal === 'block' ? 'modal show' : 'modal fade'
                    }
                    id='exampleModal'
                    tabIndex={-1}
                    role='dialog'
                    aria-labelledby='exampleModalLabel'
                    aria-hidden='true'
                  >
                    <div
                      className='modal-dialog'
                      role='document'
                      ref={wrapperRef}
                    >
                      <div className='modal-content'>
                        <div className='modal-header'>
                          <button
                            onClick={() => {
                              setDisplayModal('none');
                              // document.getElementById('header').classList.remove("sticky");
                              // console.log('kkkkkkkkk', document.getElementById('header'));
                              // document.body.style.overflow = "scroll"
                            }}
                            type='button'
                            className='close'
                            data-dismiss='modal'
                            aria-label='Close'
                          >
                            <span aria-hidden='true'>×</span>
                          </button>
                        </div>
                        <div className='modal-body'>
                          <div className='modal-body-top'></div>
                          <div className='row content-notext'>
                            <div className='col-12 col-md-8 wrap-avatar'>
                              <div className=' wrap-profiles'>
                                <div className='profiles'>
                                  <h3>{data_modal.name}</h3>
                                  <div className='position'>{data_modal.job}</div>
                                  {/* <p>{data_modal.description}</p> */}
                                </div>
                              </div>
                              <div className='avatar'>
                                <img
                                  className='img-fluid'
                                  src={data_modal.image_md}
                                  alt=''
                                />
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* end modal */}
                  {data_array.map(item => {
                    return (
                      <li>
                        <div
                          // onClick={() => {
                          //   displayModal(item);
                          // }}
                          className='box'
                          data-toggle='modal'
                          data-target='#exampleModal'
                        >
                          <div className='image'>
                            <img
                              width={202}
                              height={200}
                              src={item.image}
                              alt=''
                            />
                          </div>
                          <div className='content'>
                            <h3 className='name'>{item.name}</h3>
                            <p>{item.job}</p>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
          {/* -company*/}
          <div className='r-company'>
            <div className='container'>
              <div className='title-center'>
                <h3 className='text-white'>{trans.about.profile_title}</h3>
                <p>{trans.about.profile_text1}</p>
              </div>
              <div className='handleDown'>
                {/* <a href='#' className='text-white'>
                  <span>{trans.about.download}</span>
                  <svg
                    width={78}
                    height={40}
                    viewBox='0 0 78 40'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M77.1992 21.5592C77.5805 21.1779 77.7948 20.6607 77.7948 20.1214C77.7948 19.5821 77.5805 19.0649 77.1992 18.6836L59.9452 1.42962C59.5639 1.04828 59.0467 0.83405 58.5074 0.83405C57.9681 0.834051 57.4509 1.04828 57.0696 1.42962C56.6882 1.81095 56.474 2.32816 56.474 2.86745C56.474 3.40674 56.6882 3.92394 57.0696 4.30528L70.8526 18.0883L2.32038 18.0854C2.05301 18.0854 1.78826 18.1381 1.54125 18.2404C1.29423 18.3427 1.06979 18.4927 0.880728 18.6818C0.69167 18.8708 0.541702 19.0953 0.439387 19.3423C0.337068 19.5893 0.284411 19.854 0.284409 20.1214C0.284409 20.3888 0.337069 20.6535 0.439386 20.9005C0.541705 21.1476 0.691676 21.372 0.880733 21.5611C1.06979 21.7501 1.29423 21.9001 1.54124 22.0024C1.78826 22.1047 2.05301 22.1574 2.32038 22.1574L70.8526 22.1545L57.0696 35.9376C56.6882 36.3189 56.474 36.8361 56.474 37.3754C56.474 37.9147 56.6882 38.4319 57.0696 38.8132C57.4509 39.1945 57.9681 39.4088 58.5074 39.4088C59.0467 39.4088 59.5639 39.1946 59.9452 38.8132L77.1992 21.5592Z'
                      fill='white'
                    />
                  </svg>
                </a> */}
                {<div>
                  <a
                    // href={profile?.config_value?.url} download={(profile && profile.config_value && profile.config_value.url) ? true : false}
                    className='text-white'>
                    <span>{trans.about.download}</span>
                    <svg
                      width={78}
                      height={40}
                      viewBox='0 0 78 40'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M77.1992 21.5592C77.5805 21.1779 77.7948 20.6607 77.7948 20.1214C77.7948 19.5821 77.5805 19.0649 77.1992 18.6836L59.9452 1.42962C59.5639 1.04828 59.0467 0.83405 58.5074 0.83405C57.9681 0.834051 57.4509 1.04828 57.0696 1.42962C56.6882 1.81095 56.474 2.32816 56.474 2.86745C56.474 3.40674 56.6882 3.92394 57.0696 4.30528L70.8526 18.0883L2.32038 18.0854C2.05301 18.0854 1.78826 18.1381 1.54125 18.2404C1.29423 18.3427 1.06979 18.4927 0.880728 18.6818C0.69167 18.8708 0.541702 19.0953 0.439387 19.3423C0.337068 19.5893 0.284411 19.854 0.284409 20.1214C0.284409 20.3888 0.337069 20.6535 0.439386 20.9005C0.541705 21.1476 0.691676 21.372 0.880733 21.5611C1.06979 21.7501 1.29423 21.9001 1.54124 22.0024C1.78826 22.1047 2.05301 22.1574 2.32038 22.1574L70.8526 22.1545L57.0696 35.9376C56.6882 36.3189 56.474 36.8361 56.474 37.3754C56.474 37.9147 56.6882 38.4319 57.0696 38.8132C57.4509 39.1945 57.9681 39.4088 58.5074 39.4088C59.0467 39.4088 59.5639 39.1946 59.9452 38.8132L77.1992 21.5592Z'
                        fill='white'
                      />
                    </svg>
                  </a>
                </div>}
              </div>
            </div>
          </div>
          {/* -end company*/}
          {/* -  archivement-*/}
          <div className='r-archivement'>
            <div className='container'>
              <div className='title-center'>
                <h3>{trans.about.achievement_title}</h3>
                <p>{trans.about.achievement_text1}</p>
              </div>
              <div className='row'>
                <div className='col-6 col-md-3'>
                  <div className='box box-1'>
                    <div className='icon'>
                      <img
                        src='/assets/images/home/archivement-icon-1.png'
                        alt=''
                      />
                    </div>
                    <h2>500+</h2>
                    <p>計画</p>
                  </div>
                </div>
                <div className='col-6 col-md-3'>
                  <div className='box box-2'>
                    <div className='icon'>
                      <img
                        src='/assets/images/home/archivement-icon-2.png'
                        alt=''
                      />
                    </div>
                    <h2>200+</h2>
                    <p>クライアント</p>
                  </div>
                </div>
                <div className='col-6 col-md-3'>
                  <div className='box box-3'>
                    <div className='icon'>
                      <img
                        src='/assets/images/home/archivement-icon-3.png'
                        alt=''
                      />
                    </div>
                    <h2>100+</h2>
                    <p>エンジニア</p>
                  </div>
                </div>
                <div className='col-6 col-md-3'>
                  <div className='box box-4'>
                    <div className='icon'>
                      <img
                        src='/assets/images/home/archivement-icon-4.png'
                        alt=''
                      />
                    </div>
                    <h2>10+</h2>
                    <p>専門家</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* - end archivement-*/}
          {/* customer */}
          <div className='r-customer'>
            <div className='container'>
              <div className='title-center'>
                <h3>{trans.about.customer_title}</h3>
              </div>
            </div>
            <div className='container-fluid'>
            <ul className='brands-list'>
              <li>
                <img
                  src='/assets/images/about/customer/fujitsu.svg'
                  alt='Fujitsu'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/viettel.svg'
                  alt='Viettel'
                />
              </li>
              <li>
                <img src='/assets/images/about/customer/ricoh.svg' alt='Ricoh' />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/qualcom.svg'
                  alt='QUALCOMM'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/intel.svg'
                  alt='Intel'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/robot.svg'
                  alt='Robot&Facom'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/fpt.svg'
                  alt='FPT'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/luvina.svg'
                  alt='Luvina'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/trinam.svg'
                  alt='Tri nam group'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/tueduc.svg'
                  alt='Tue duc'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/nhg.svg'
                  alt='NHG'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/dhvinh.svg'
                  alt='Vinh university'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/bogddt.svg'
                  alt='Bộ GD-ĐT'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/bkhn.svg'
                  alt='Dai hoc bach khoa'
                />
              </li>
              <li>
                <img
                  src='/assets/images/about/customer/uneti.svg'
                  alt='UNETI'
                />
              </li>
            </ul>
          </div>
            <div className='map'>
              <img
                className='w-100'
                src='/assets/images/about/map-new.png'
                alt='map'
              />
            </div>
          </div>
          {/* end customer */}
        </div>
      </div>
    </>
  );
}
